import { ShapesMenuProps } from "../../../types/type";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import React from "react";

const ShapesMenu = ({
  item,
  activeElement,
  handleActiveElement,
  handleImageUpload,
  imageInputRef,
  svgInputRef,
  handleSvgUpload,
}: ShapesMenuProps) => {
  const isDropdownElem = item.value.some(
    (elem) => elem?.value === activeElement.value
  );

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild className="no-ring">
          <div
            className="relative object-contain w-full h-full flex items-center justify-center"
            onClick={() => handleActiveElement(item)}
          >
            {(isDropdownElem && (
              <React.Fragment>
                <activeElement.icon size={18} className="invert" />
              </React.Fragment>
            )) || (
              <React.Fragment>
                <item.icon size={18} />
              </React.Fragment>
            )}
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="mt-2 flex flex-col gap-y-1 border-none bg-black py-4 text-white">
          {item.value.map((elem) => {
            const IconComponent = elem!.icon;

            return (
              <div
                key={elem?.name}
                onClick={() => {
                  handleActiveElement(elem);
                }}
                className={`flex h-fit justify-between gap-10 rounded-none px-5 py-3 focus:border-none hover:cursor-pointer hover:bg-primary ${
                  activeElement.value === elem?.value ? "bg-primary" : ""
                }`}
              >
                <div className="group flex items-center gap-2">
                  <IconComponent size={18} />
                  <p
                    className={`text-sm 
                   ${
                     activeElement.value === elem?.value
                       ? "text-white"
                       : "text-white"
                   }`}
                  >
                    {elem?.name}
                  </p>
                </div>
              </div>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>

      <input
        type="file"
        className="hidden"
        ref={imageInputRef}
        accept="image/jpeg, image/png, image/gif, image/webp"
        onChange={handleImageUpload}
      />

      <input
        type="file"
        className="hidden"
        ref={svgInputRef}
        accept="image/svg+xml"
        onChange={handleSvgUpload}
      />
    </>
  );
};

export default ShapesMenu;
